import { render } from "./indexGroup.vue?vue&type=template&id=369e021a&scoped=true"
import script from "./indexGroup.vue?vue&type=script&lang=js"
export * from "./indexGroup.vue?vue&type=script&lang=js"

import "./indexGroup.vue?vue&type=style&index=0&id=369e021a&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369e021a"]])

export default __exports__